import type { Hero } from '@/types/content.types';

import { apiClient } from '../api-client';
import { API_ROUTES } from '../api-config';

/**
 * Get hero by type (piercing or tattoo)
 */
export async function getHeroByType(type: 'piercing' | 'tattoo'): Promise<Hero> {
  return apiClient.get<Hero>(API_ROUTES.HERO_BY_TYPE(type));
}

/**
 * Get hero by ID
 */
export async function getHeroById(id: string): Promise<Hero> {
  return apiClient.get<Hero>(API_ROUTES.HERO_BY_ID(id));
}

/**
 * Get all heroes
 */
export async function getHeroes(): Promise<Array<Hero>> {
  return apiClient.get<Array<Hero>>(API_ROUTES.HEROES);
}
